import { Typography } from '@/components/common';
import clsx from 'clsx';
import { format } from 'date-fns';

interface Props {
	title: string;
	time: string;
	classNameTitle?: string;
}

export function ContentTitle({ title, time, classNameTitle }: Props) {
	return (
		<div className="min-w-0 w-full max-w-full">
			<Typography
				type="semibold-20"
				className={clsx(
					'min-w-0 text-left line-clamp-2 break-words [overflow-wrap:anywhere]',
					classNameTitle
				)}
			>
				{title}
			</Typography>
			{time && (
				<Typography
					type="regular-12"
					className="text-gray-35 min-w-0 text-left break-words"
				>
					{`Signed on ${format(new Date(time), `MMMM d, yyyy`)}`}
				</Typography>
			)}
		</div>
	);
}
